import { z } from "zod";
export const PathParamsIdString = z
    .object({
    id: z.string(),
})
    .meta({ ref: "PathParamsIdString" });
export const SearchParamsPagination = z
    .object({
    skip: z.coerce.number(),
    take: z.coerce.number(),
})
    .partial()
    .meta({ ref: "SearchParamsPagination" });
export const StatusOk = z
    .object({
    status: z.literal("ok"),
})
    .meta({ ref: "StatusOk" });
export const Ok = z.literal("ok").meta({ ref: "Ok" });
export const ResponseError = z.object({
    translationCode: z.string(),
    message: z.string(),
});
export const ResponseBodyWrapper = (s) => z.object({
    data: s,
    error: ResponseError.optional(),
});
